export default "__VITE_ASSET__3dca75f5__"